import {load} from '@shopify/theme-sections';

import '../sections/most-loved-blog-posts';

if (document.body.classList.contains('template-blog')) {
  if (document.body.id === 'tutorials') {
    load('*');
  }
}
